<template>
<div>
  <div class="arm-arq-qrcode" :key="timeRecebe">
    <!-- SETA A MASCARA -->
    <div class="mascara-geral" v-if="upload !== null">
      <div class="quadrado noselect">
        <RF-Progress-Upload-Donwload v-if="upload !== null"
          :cpntMensagem="upload.mensagem"
          :cpntTotal="upload.total"
          :cpntTransferido="upload.transferido"
          :cpntHeight="'30px'"
        ></RF-Progress-Upload-Donwload>
      </div>
    </div>

    <!-- ADCIONA A MASCARA CARREGANDO -->
    <div class="mascara" v-if="statusGeral === 'carregando'">
      <RF-Status-2 :cpntStatus='statusGeral'></RF-Status-2>
    </div>
    
    <!-- MOSTRA O CONTEUDO DA PAGINA -->
    <div v-else class="conteudo">
      <div class="logotipo">
        <img :src="logo" :alt="ldu.nome"/>
      </div>

      <div class="titulo">
        Está paginá é exclusiva para anexar arquivos.
      </div>

      <div class="seletor">
        <input :id="input.id" name="files[]" type="file" capture="" ref="input" @change="armArquivosRecebeQrCodeOnChangeInput"/>
        <label :for="input.id" :class="input.class"><strong v-html="input.texto"></strong></label>
      </div>

      <div style="margin-top: 20px;">
        Abaixo estão listados os arquivos anexados neste registro
        <table v-if="Object.keys(registro).length >= 1">
          <tr class="cabecalho" v-if="(dados.refMod === 10 || dados.refMod === 11)">
            <td>
              <div v-html="registro.status === '2' ? armArquivosRecebeQrCodeConverterDemanda : 'Orçamento'"></div>
              <span v-html="demEditarCabFormatarCodigo()"></span>
            </td>
            <td v-if="[ '', null, undefined, '0' ].indexOf(registro.id_con) === -1">
              <div>Cliente</div>
              <span v-html="registro.id_con_nome"></span>
            </td>
            <td v-if="[ '', null, undefined, '0' ].indexOf(registro.id_vei) === -1">
              <div>Veículo</div>
              <!-- COLOCA O NOME DO VEICULO -->
              <span v-html="registro.id_vei_placa + ' ('"></span>

              <!-- COLOCA O MODELO NOVO DA API -->
              <template v-if="[ '', null, undefined ].indexOf(registro.id_vei_marca) === -1 || [ '', null, undefined ].indexOf(registro.id_vei_modelo) === -1">
                <span v-if="[ '', null, undefined ].indexOf(registro.id_vei_marca) === -1" v-html="registro.id_vei_marca"></span>
                <span v-if="[ '', null, undefined ].indexOf(registro.id_vei_modelo) === -1" v-html="' ' + registro.id_vei_modelo"></span>
              </template>

              <!-- COLOCA O MODELO ANTIGO DA API-->
              <template v-else>
                <span v-if="[ '', null, undefined ].indexOf(registro.id_vei_id_mar_nome) === -1" v-html="registro.id_vei_id_mar_nome"></span>
                <span v-if="[ '', null, undefined ].indexOf(registro.id_vei_id_mod_nome) === -1" v-html="' ' + registro.id_vei_id_mod_nome"></span>
              </template>
              )

              <!-- VERIFICA SE O VEICULO ESTA EXCLUIDO -->
              <b v-if='registro.id_vei_status !== "1"' v-html="'[Excluído]'"></b>
            </td>
            <td v-if="[ '', null, undefined, '0' ].indexOf(registro.id_pet) === -1">
              <div>Pet</div>
              <!-- COLOCA O NOME DO PET -->
              <span v-html="registro.id_pet_nome"></span>

              <!-- COLOCA O NOME DO PET -->
              <span v-if="[ '', null, undefined ].indexOf(registro.id_pet_subespecie_nome) === -1" v-html="' (' + registro.id_pet_subespecie_nome + ')'"></span>

              <!-- VERIFICA SE O PET ESTA EXCLUIDO -->
              <b v-if='registro.id_pet_status !== "1"' v-html="'[Excluído]'"></b>
            </td>
          </tr>
          <tr class="cabecalho" v-else-if="dados.refMod === 12">
            <td>
              <div>Código</div>
              <span v-html="registro.codigo"></span>
            </td>
            <td>
              <div>Nome</div>
              <span v-html="registro.nome"></span>
            </td>
          </tr>
        </table>
      </div>

      <div class="arquivos" v-if="[ '', null, undefined ].indexOf(arquivos) === -1 && Object.keys(arquivos).length >= 1" :key="timeRecebe">
        <template v-for="(a, index) in arquivos">
          <Armazenamento-Arquivos-Icone v-if="[ '', null, undefined ].indexOf(arquivos[index].time) === -1" :key="'div-' + arquivos[index].time + '-' + arquivos[index].id" 
            :cpntId='arquivos[index].id'
            :cpntFileName='arquivos[index].filename'
            :cpntFileExt='arquivos[index].ext'
            :cpntFileSizeThumbnail='arquivos[index].size_bytes_thumbnail'
            :cpntThumbnail='arquivos[index].thumbnail_b64'
          ></Armazenamento-Arquivos-Icone>
        </template>
      </div>    
    </div>
  </div>
</div>
</template>

<style scoped>
.arm-arq-qrcode {
  /* position: absolute; */
}
.arm-arq-qrcode {
  /* padding-top: 150px; */
  text-align: center;
}
  .arm-arq-qrcode > .mascara-geral {
    width: calc(100%);
    height: 100%;
    background: rgba(0, 0, 0, 0.28);
    /* position: fixed;
    top: 0px;
    left: 0px; */
    z-index: 2700;
    color: #fff;
  }
    .arm-arq-qrcode > .mascara-geral > .quadrado {
      width: 95%;
      min-height: 220px;
      margin: 0px auto;
      /* margin-top: calc(100% - (220px / 2) - 20px); */
      margin-top: 30px;
      /* margin-left: calc(-2%); */
      background: rgba(233, 233, 233, 0.95);
      color: #000;
      border: 1px solid #ccc;
      border-radius: 10px;
      padding: 20px
    }
  .arm-arq-qrcode > .conteudo {
    width: 98%;
    margin: 0px auto;
    padding-top: 150px;
    /* position: fixed; */
    text-align: center;
  }
  .arm-arq-qrcode > .conteudo > .titulo {
    font-size: 18px;
    margin: 10px 0px;
  }
  .arm-arq-qrcode > .conteudo > .seletor {
    padding: 2px 0px;
    margin-top: 20px;
  }
    .arm-arq-qrcode > .conteudo > .seletor > input {
      display: none;
    }
  .arm-arq-qrcode > .conteudo > div > table {
    width: calc(100% - 20px);
    max-width: 500px;
    margin: 0px auto;
    margin-top: 5px;
    border-collapse: separate;
  }
      .arm-arq-qrcode > .conteudo > div > table > .cabecalho > td {
        background: #e9e9e9;
        border: 1px solid #ccc;
        padding: 4px;
        vertical-align: middle;
      }
      .arm-arq-qrcode > .conteudo > div > table > .cabecalho > td:first-child {
        border-right: none;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }
      .arm-arq-qrcode > .conteudo > div > table > .cabecalho > td:last-child {
        border-left: none;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
      }
        .arm-arq-qrcode > .conteudo > div > table > .cabecalho > td > div {
          font-weight: bold;
        }
  .arm-arq-qrcode > .conteudo > .arquivos {
    margin-top: 10px;
  }
    .arm-arq-qrcode > .conteudo > .arquivos > div {
      max-width: 130px;
      word-break: break-word;
    }
</style>

<style>
html, body, #rotina-facil-web, .rf-pag-acesso, #mensagem_cliente {
  width: initial !important;
  height: initial !important;
}

.arm-arq-qrcode > .mascara-geral > .quadrado > div > div > div {
  background: #000 !important;
}
</style>

<script>
export default {
  components: {
    'RF-Status-2': () => import('@/components/rf-geral/status/RF-Status-2.vue'),
    'Armazenamento-Arquivos-Icone': () => import('@/components/armazenamento-arquivos/Armazenamento-Arquivos-Icone.vue'),
    'RF-Progress-Upload-Donwload': () => import('@/components/rf-geral/progress/RF-Progress-Upload-Donwload.vue')
  },
  data: function () {
    return {
      time: '',
      timeRecebe: '',
      statusGeral: 'carregando',
      // mascara: false,
      input: {
        id: 'ven-editar-anexo-novo',
        status: '',
        texto: 'Clique aqui para anexar arquivos',
        value: '',
        disabled: false,
        tipo: 'texto',
        class: [ 'btn', 'btn-default' ]
      },
      dados: {},
      ldu: {},
      logo: '',
      registro: {},
      arquivos: {},
      bottoes: [
        { id: '', status: '', texto: 'Câmera', mostrar: false },
        { id: '', status: '', texto: 'Galeria', mostrar: false }
      ],
      upload: null,

      cpntDemanda: '',
      cpntDemandaId: ''
    }
  },
  mounted: function () {
    this.armArquivosRecebeQrCodeIniciar()
  },
  destroyed: function () {
    this.$store.state.WEB_SOCKET_OBSERVADOR('ArmArquivo', 'recebe-qrcode', null)
  },
  methods: {
    armArquivosRecebeQrCodeIniciar: function () {
      var self = this

      // CHAMA A FUNÇÃO PARA SETAR O STATUS
      self.armArquivosRecebeQrCodeSetarStatusGeral('carregando')

      // VERIFICA SE RECEBEU OS PARAMETROS
      if ([ '', null, undefined ].indexOf(self.$route) === -1 && [ '', null, undefined ].indexOf(self.$route.params) === -1 && [ '', null, undefined ].indexOf(self.$route.params.link) === -1) {
        // FAZ A COMUNICAÇÃO COM A API
        self.$store.state.comunicaAPI('/subase/qrcode/get/' + self.$route.params.link, 'GET', null, function (apiSuccess) {
          if ([ '', null, undefined ].indexOf(apiSuccess.data) !== -1 || [ '', null, undefined ].indexOf(apiSuccess.data.j_conteudo) !== -1) {
            self.$router.push({ name: 'con_exi', params: { error: 'WEB [500]: Os parametros recebidos para o link, não são válidos.' } })
          } else {
            // SETA OS DADOS RECEBIDOS
            self.dados = JSON.parse(apiSuccess.data.j_conteudo)

            // VERIFICA SE NÃO FOI RECEBIDO O CTS
            if ([ '', null, undefined ].indexOf(self.dados) !== -1) {
              self.dados.cts = '1'
            }

            // IMPORTA A FUNÇÃO
            const SESSAO_TRATAR_DADOS_TOKEN = require('@/assets/js/Sessao.js').SESSAO_TRATAR_DADOS_TOKEN
            
            // CARREGA OS DADOS DO TOKEN
            SESSAO_TRATAR_DADOS_TOKEN(self.dados)

            // SETA OS DADOS RECEBIDOS
            self.arquivos = {}

            // SETA A INFORMAÇÃO DA DEMANDA A SER UTILIZADA
            switch (self.dados.refMod) {
              case 11:
                self.cpntDemanda = 'compra'
                break

              case 10:
                self.cpntDemanda = 'venda'
                break
            }

            // ADICIONA O OBSERVADOR
            self.$store.state.WEB_SOCKET_OBSERVADOR('ArmArquivo', 'recebe-qrcode', function (evento) {
              // ADICIONA O ARQUIVO RECEBIDO
              for (var indexF in evento) {
                // INICIA A VARIAVEL
                var registro = null

                // VERIFICA SE O VALOR RECEBIDO É REFERENTE AO CAMPO ABERTO
                switch (self.dados.refMod) {
                  case 9:
                    if (evento[indexF].id_financeiro === self.dados.refId.toString()) {
                      registro = evento[indexF]
                    }
                    break

                  case 12:
                    if (evento[indexF].id_pro_imagem === self.dados.refId.toString()) {
                      registro = evento[indexF]
                    }
                    break

                  case 11:
                    if (evento[indexF].dem_compra === self.dados.refId.toString()) {
                      registro = evento[indexF]
                    }
                    break

                  case 10:
                    if (evento[indexF].cod_venda === self.dados.refId.toString()) {
                      registro = evento[indexF]
                    }
                    break
                }

                if ([ '', null, undefined ].indexOf(registro) === -1) {
                  switch (registro.status) {
                    case '1':
                      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                      registro.time = new Date().getTime()

                      // VERIFICA SE RECEBEU ALGUM THUMBNAIL
                      if ([ '', null, undefined ].indexOf(registro.thumbnail_b64) !== -1) {
                        registro.thumbnail_b64 = ''
                      }
          
                      // ADICIONA O ARQUIVO
                      self.arquivos[registro.id] = registro
                      break

                    // SE ELE FOI ENVIADO PARA LIXEIRA
                    default:
                      delete self.arquivos[registro.id]
                      break
                  }
                }
              }

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.timeRecebe = new Date().getTime().toString() + '--' + Object.keys(self.arquivos)

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            }, 'usu')

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // IMPORTA A FUNÇÃO PARA ATUAIZAR OS DADOS DA API
            const FUN_TRATAR_RETONOS_E_CALLBACK = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_RETONOS_E_CALLBACK

            // EXECUTA A FUNÇÃO DE CALLBACKS
            FUN_TRATAR_RETONOS_E_CALLBACK(self, {
              armArquivosRecebeQrCodeBuscarLogo: [ ],
              armArquivosRecebeQrCodeBuscarRegistro: [ ],
              armArquivosRecebeQrCodeBuscarArquivos: [ ],
              armArquivosRecebeQrCodeFinalizar: [ 'armArquivosRecebeQrCodeBuscarLogo', 'armArquivosRecebeQrCodeBuscarRegistro', 'armArquivosRecebeQrCodeBuscarArquivos' ]
            },
            {
              armArquivosRecebeQrCodeBuscarLogo: function (chave, callback, self) { self.armArquivosRecebeQrCodeBuscarLogo(self, function () { callback(chave) } ) },
              armArquivosRecebeQrCodeBuscarRegistro: function (chave, callback, self) { self.armArquivosRecebeQrCodeBuscarRegistro(self, function () { callback(chave) } ) },
              armArquivosRecebeQrCodeBuscarArquivos: function (chave, callback, self) { self.armArquivosRecebeQrCodeBuscarArquivos(self, function () { callback(chave) } ) },
              armArquivosRecebeQrCodeFinalizar: function (chave, callback, self) { self.armArquivosRecebeQrCodeFinalizar(self, function () { callback(chave) } ) },
            })
          }
        }, self.armArquivosRecebeQrCodeSetarStatusGeral)
      } else {
        self.$router.push({ name: 'con_exi', params: { error: 'WEB [409]: Link recebido é inválido.' } })
      }
    },
    teste_teste: function (self, porcentagem = null) {
      // INICIA A VARAIVEL
      var registro = { total: 10760269, transferido: 0, porcentagem: porcentagem }

      // VERIFICA QUAL É A PORCENTAGEM QUE DEVE APLICAR
      registro.porcentagem =  registro.porcentagem === null ? 0 : (registro.porcentagem + 2.5)

      // VERIFICA SE DEVE CONTINUAR CALCULANDO
      if (registro.porcentagem <= 100) {
        // CALCULA QUANTO DEVE COLOCAR COMO TRANSFERIDO
        registro.transferido = registro.total * (registro.porcentagem / 100)

        // CHAMA A FUNÇÃO PARA ATUALIZAR OS DADOS NA TELA
        self.armArquivosRecebeQrCodeProgress('Realizando o upload do arquivo.', { result: registro })
  
        // CHAMA A FUNÇÃO PARA REINICIAR
        setTimeout(function () { self.teste_teste(self, registro.porcentagem) }, 350)
      }
    },
    armArquivosRecebeQrCodeSetarStatusGeral: function (status) {
      // SETA O STATUS DA TELA
      this.statusGeral = status

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()

      // VERIFICA SE O STATUS É DIFERENTE DA PAGINA
      if ([ '', 'carregando' ].indexOf(status) === -1) {
        this.$store.commit('SET_APP_STATUS', status)
      }
    },
    armArquivosRecebeQrCodeBuscarLogo: function (self, callback = null) {
      // CHAMA FUNÇÃO PARA COMUNICAR COM API
      self.$store.state.comunicaAPI('/config/logo/get/web/', 'GET', 'link', function (apiSuccess) {
        // COLOCA A INFORMAÇÃO QUE A IMAGEM É B64
        if (apiSuccess.data.indexOf('http') === -1) {
          apiSuccess.data = 'data:image/jpeg;base64, ' + apiSuccess.data
        }
        
        // CHAMA A FUNÇÃO CALLBACK PARA CONTINUAR O PROCESSAMENTO
        self.logo = apiSuccess.data

        // EXECUTA O CALLBACK RECEBIDO
        if (callback !== null) {
          callback()
        }
      }, self.armArquivosRecebeQrCodeSetarStatusGeral, null)
    },
    armArquivosRecebeQrCodeBuscarCadastro: function (self, callback = null) {
      // CHAMA FUNÇÃO PARA COMUNICAR COM API
      self.$store.state.comunicaAPI('/config/cadastro/get', 'GET', null, function (apiSuccess) {
        // SETA OS DADOS RECEBIDOS
        self.ldu = apiSuccess.data

        // EXECUTA O CALLBACK RECEBIDO
        if (callback !== null) {
          callback()
        }
      }, self.armArquivosRecebeQrCodeSetarStatusGeral, null)
    },
    armArquivosRecebeQrCodeBuscarArquivos: function (self, callback = null, ids = []) {
      // INICIA O QUERY GET
      var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }

      // VERIFICA O TIPO DO REGISTRO
      switch (self.dados.refMod) {
        case 9:
          queryGet.where = { aAnd: [ { f: 'id_financeiro', o: '=', v: self.dados.refId }, { f: 'status', o: '=', v: '1' } ] }
          break

        case 10:
          queryGet.where = { aAnd: [ { f: 'cod_venda', o: '=', v: self.dados.refId }, { f: 'status', o: '=', v: '1' } ] }
          break

        case 11:
          queryGet.where = { aAnd: [ { f: 'dem_compra', o: '=', v: self.dados.refId }, { f: 'status', o: '=', v: '1' } ] }
          break

        case 12:
          queryGet.where = { aAnd: [ { f: 'id_pro_imagem', o: '=', v: self.dados.refId }, { f: 'status', o: '=', v: '1' } ] }
          break
      }

      // BUSCA APENAS OS ARQUIVOS SOLICITADOS
      if (ids.length >= 1) {
        queryGet.where.aAnd.push({ f: 'id', o: 'in', v: ids.join() })
      }

      // CHAMA FUNÇÃO PARA COMUNICAR COM API
      self.$store.state.comunicaAPI('/arm-arquivo/get/', 'GET', queryGet, function (apiSuccess) {
        // INICIA A VARIAVEL PARA SETAR OS IDS
        var thumbnailIds = []

        for (var key in apiSuccess.data) {
          // INICIA A VARIAVEL DO ICONE DO ARQUIVO
          apiSuccess.data[key].time = 1
          apiSuccess.data[key].thumbnail_b64 = ''

          // INICIA O VETOR
          self.arquivos[apiSuccess.data[key].id] = apiSuccess.data[key]

          // ADICIONA O ID
          if ([ '', null, undefined ].indexOf(apiSuccess.data[key].size_bytes_thumbnail) === -1 && Number(apiSuccess.data[key].size_bytes_thumbnail) > 0) {
            thumbnailIds.push(apiSuccess.data[key].id)
          }
        }

        // CHAMA A FUNÇÃO PARA BUSCAR OS ICONES
        self.armArquivosRecebeQrCodeBuscarThumbnail('thumbnail_b64', thumbnailIds, function (registros) {
          // SETA OS ICONES RECEBIDOS
          for (var key in registros) {
            // SETA O ICONE
            self.arquivos[registros[key].id].thumbnail_b64 = registros[key].thumbnail_b64

            // SETA O TIME PARA ATUALIZAR
            self.arquivos[registros[key].id].time = new Date().getTime()
          }

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // EXECUTA O CALLBACK RECEBIDO
          if (callback !== null) {
            callback()
          }
        })
      }, self.armArquivosRecebeQrCodeSetarStatusGeral)
    },
    armArquivosRecebeQrCodeBuscarThumbnail: function (tipo, ids, callback, qtde = 300, ini = null, fim = null, retornos = []) {
      var self = this

      // SETA OS DADOS QUE SERÁ BUSCADO
      if (ini === null && fim === null) {
        ini = 0
        fim = qtde
      } else if (ids.length > (ini + qtde)) {
        ini += qtde
        fim += qtde
      } else {
        ini = null
        fim = null
      }

      if (ini !== null && fim !== null) {
        // PEGA OS IDS QUE DEVE BUSCAR
        var busca = ids.slice(ini, fim)

        // INICIA O QUERYGET
        var queryGet = { lot: [] }
        
        // ADICIONA O VALOR AO VETOR
        for (var key in busca) {
          queryGet.lot.push({ id: busca[key], tipo: [ tipo ] })
        }

        // FAZ A BUSCA NA API
        self.$store.state.comunicaAPI('/arm-arquivo/arquivo/get/', 'GET', queryGet, function (apiSuccess) {
          // ADICIONA OS VALORES NO VETOR
          for (var index in apiSuccess.lot) {
            switch (apiSuccess.lot[index].code) {
              case '200':
                retornos.push(apiSuccess.lot[index].data)
                break

              default:
                self.$store.state.msgWarn('API [' + apiSuccess.lot[index].code + ']: ' + apiSuccess.lot[index].message, 'danger')
                break
            }
          }

          // FAZ A QUEBRA O VALOR RECEBIDO E CHAMA A FUNÇÃO PARA BUSCAR
          self.armArquivosRecebeQrCodeBuscarThumbnail(tipo, ids, callback, qtde, ini, fim, retornos)
        }, self.armArquivosRecebeQrCodeSetarStatusGeral, null)
      } else {
        callback(retornos)
      }
    },
    armArquivosRecebeQrCodeBuscarRegistro: function (self, callback = null) {
      // INICIA A VARIAVEL DA ROTA QUE DEVE SER UTILIZADA
      var route = ''

      // SETA O METHOD QUE DEVE CHAMAR
      var method = 'GET'

      // INICIA O QUERY GET
      var queryGet = { type: 'list', limit: { row: 0, qty: 1 } }

      // VERIFICA O TIPO DO REGISTRO
      switch (self.dados.refMod) {
        case 10:
          // SETA A ROTA QUE DEVE UTILIZAR
          route = '/venda/get'

          // SETA O METHOD QUE DEVE CHAMAR
          method = 'POST'

          // SETA OS CAMPOS QUE DEVE RETORNAR
          queryGet.field = {
            cod_venda: null, 
            status: null,
            id_pet: { j: { nome: null, id_pet_subespecie: { j: { j_subespecie: { a: 'id_pet_subespecie_nome' } } }, status: null } },
            id_vei: { j: { placa: null, id_mod: { j: { nome: null } }, ref_modelo: { j: { j_modelo: null } }, status: null } },
            id_con: { j: { nome: null, empresa: null, cnpj_cpf: null, pessoa: null, pj_sn: null, id_estado: null, status: null } },
          }

          // REMOVE A CHAVE SE NÃO TIVER O PACOTE
          if (self.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, null, null, null, null, false) === false) {
            delete queryGet.field.id_vei
          }

          // REMOVE A CHAVE SE NÃO TIVER O PACOTE
          if (self.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 28 ], null, null, null, null, null, false) === false) {
            delete queryGet.field.id_vei
          }

          // SETA O WHERE DO CAMPO
          queryGet.where = { f: 'cod_venda', o: '=', v: self.dados.refId }
          break

        case 11:
          // SETA A ROTA QUE DEVE UTILIZAR
          route = '/demanda/dem-compra/get'

          // SETA O METHOD QUE DEVE CHAMAR
          method = 'POST'

          // SETA OS CAMPOS QUE DEVE RETORNAR
          queryGet.field = {
            dem_compra: null, 
            status: null,
            id_con: { j: { nome: null, empresa: null, cnpj_cpf: null, pessoa: null, pj_sn: null, id_estado: null, status: null } },
          }

          // SETA O WHERE DO CAMPO
          queryGet.where = { f: 'dem_compra', o: '=', v: self.dados.refId }
          break

        case 6:
          // SETA A ROTA QUE DEVE UTILIZAR
          route = '/produto/get'

          // SETA O METHOD QUE DEVE CHAMAR
          method = 'POST'

          // SETA OS CAMPOS QUE DEVE RETORNAR
          queryGet.field = {
            id: null,
            codigo: null,
            nome: null
          }

          // SETA O WHERE DO CAMPO
          queryGet.where = { f: 'id', o: '=', v: self.dados.refId }
          break

        case 9:
          // SETA A ROTA QUE DEVE UTILIZAR
          route = '/financeiro/get'

          // SETA O METHOD QUE DEVE CHAMAR
          method = 'POST'

          // SETA OS CAMPOS QUE DEVE RETORNAR
          queryGet.field = {
            id: null
          }

          // SETA O WHERE DO CAMPO
          queryGet.where = { f: 'id', o: '=', v: self.dados.refId }
          break
      }

      // VERIFICA SE FOI GERADO OS DADOS
      if (route === '') {
        self.$router.push({ name: 'con_exi', params: { error: 'WEB [500]: Erro ao buscar dados do registro' } })
      } else {
        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        self.$store.state.comunicaAPI(route, method, queryGet, function (apiSuccess) {
          // SETA OS DADOS RECEBIDOS
          self.registro = apiSuccess.data[0]
  
          // EXECUTA O CALLBACK RECEBIDO
          if (callback !== null) {
            callback()
          }
        }, self.armArquivosRecebeQrCodeSetarStatusGeral, null)
      }
    },
    armArquivosRecebeQrCodeFinalizar: function (self, callback = null) {
      // CHAMA A FUNÇÃO PARA SETAR O STATUS
      self.armArquivosRecebeQrCodeSetarStatusGeral('')

      // CHAMA A FUNÇÃO PARA DAR FOCUS NO INPUT E ABRIR A CAMERA
      self.armArquivosRecebeQrCodeDarFocusCampo(self)

      // self.teste_teste(self)

      // EXECUTA O CALLBACK RECEBIDO
      if (callback !== null) {
        callback()
      }
    },
    armArquivosRecebeQrCodeDarFocusCampo: function (self, tentativa = 0) {
      if (tentativa <= 10) {
        if ([ '', null, undefined ].indexOf(self.$refs) !== -1 || [ '', null, undefined ].indexOf(self.$refs.input) !== -1) {
          setTimeout(function () { self.armArquivosRecebeQrCodeDarFocusCampo(self, (tentativa + 1)) }, 200)
        } else {
          // VERIFICA SE O NAVEGADOR SUPORTA O EVENTO
          if(document.createEvent) {
            // CRIA O EVENTO PARA ENVIAR PARA O INPUT
            var evt = document.createEvent('MouseEvents')

            // SETA O EVENTO DO TIPO CLICK
            evt.initEvent('click', true, false)

            // DISPARA O EVENTO 
            self.$refs.input.dispatchEvent(evt)
          }
        }
      }
    },
    armArquivosRecebeQrCodeOnChangeInput: function (event) {
      // LIMPA OS DADOS DO INPUT
      this.input.value = ''

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()

      // PEGA O ARQUIVO
      var arquivo = [ '', null, undefined ].indexOf(event.clipboardData) === -1 ? event.clipboardData : event.target

      // VERIFICA SE TEM ALGUM ARQUIVO PARA SALVAR
      if (arquivo.files.length >= 1) {
        // DESABILITA O INPUT PARA INSERIR NOVO
        this.input.status = 'carregando'

        // DESABILITA O INPUT PARA INSERIR NOVO
        this.input.disabled = true

        // INICIAR O INPUT QUE RECEBE OS ARQUIVOS
        this.input.value = []

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // CHAMA A FUNÇÃO PARA SALVAR OS ARQUIOS
        this.armArquivosRecebeQrCodeArquivoLer(arquivo.files)
      }
    },
    armArquivosRecebeQrCodeProgress: function (mensagem, retornos) {
      // INICIA A VARIAVEL QUE VAI RECEBER OS DADOS
      var dados = { total: 0, transferido: 0 }

      // PEGA OS DADOS RECEBIDOS
      if ([ '', null, undefined ].indexOf(retornos.result) === -1) {
        dados = retornos.result
      }

      // ALTERA A MENSAGEM DO CAMPO
      dados.mensagem = mensagem

      // SETA OS DADOS RECEBIDOS DA PARCIAL
      this.upload = dados

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    armArquivosRecebeQrCodeArquivoLer: function (files) {
      var self = this

      // IMPORA A FUNÇÃO PARA ATUALIZAÇÃO
      const ARMAZENAR_ARQUIVO_S3 = require('@/assets/js/Armazenar-Arquivos.js').ARMAZENAR_ARQUIVO_S3

      // CHAMA A FUNÇÃO PARA ENVIAR O ARQUIVO
      ARMAZENAR_ARQUIVO_S3(files, Number(self.dados.refMod), Number(self.dados.refId), self.armArquivosRecebeQrCodeProgress).then(function (retorno) {
        // TRATA A MENSAGEM RECEBIDA
        self.$store.state.TRATAR_RET_LOT_API({ lot: retorno }, null, 'API [200]: Arquivo(s) enviado(s) com sucesso.')

        // SETA O STATUS DO BUTTON
        self.input.status = ''

        // DESABILITA O INPUT PARA INSERIR NOVO
        self.input.disabled = false

        // SETA OS ARQUIVOS RECEBIDOS
        self.input.value = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // CHAMA A FUNÇÃO PARA FECHAR E ATUALIZAR OS DADOS ATRAS
        self.upload = null
      }).catch(self.armArquivosRecebeQrCodeSetarStatusGeral)
      // var self = this

      // // INICIA A LEITURA DO ARQUIVO
      // var reader = new FileReader()

      // // SETA FUNÇÃO DE SUCESSO DE LEITURA
      // reader.onload = function () {
      //   // SETA OS ARQUVOS QUE SERÁ ENVIADO
      //   self.input.value.push({ filename: files[index].name, arquivo_b64: window.btoa(reader.result) })

      //   // CHAMA A FUNÇÃO PARA LER O ARQUIVO
      //   if (index < files.length) {
      //     self.armArquivosRecebeQrCodeArquivoLer(files, (index + 1))
      //   }
      // }

      // // REALIZA A LEITURADO DO CAMPO OU FINALIZA O PROCESSO
      // switch (index < files.length) {
      //   case true:
      //     reader.readAsBinaryString(files[index])
      //     break

      //   case false:
      //   default:
      //     self.armArquivosRecebeQrCodeArquivoSalvar()
      //     break
      // }
    },
    // armArquivosRecebeQrCodeArquivoSalvar: function () {
    //   if ([ '', null, undefined ].indexOf(this.input.value) === -1 && this.input.value.length >= 1) {
    //     var self = this

    //     // ATIVA A MASCARA DE ENVIANDO
    //     self.mascara = true

    //     // INICIA O VETOR QUE SERÁ ENVIADO PARA API
    //     var formData = []
    //     var registro = {}

    //     // VERIFICA O TIPO DO REGISTRO
    //     switch (self.dados.refMod) {
    //       case 17:
    //         registro.cod_venda = self.dados.refId
    //         break
    //     }

    //     // ADICIONA TODOS OS ARQUIVOS EXISTENTES
    //     for (var key in this.input.value) {
    //       formData.push(Object.assign(self.input.value[key], registro))
    //     }
        
    //     // CONVERTE O REGISTRO EM LOT
    //     formData = { lot: formData }

    //     // FAZ A COMUNICAÇÃO COM A API
    //     self.$store.state.comunicaAPI('/arm-arquivo', 'POST', formData, function (apiSuccess) {
    //       // TRATA A MENSAGEM RECEBIDA
    //       self.$store.state.TRATAR_RET_LOT_API(apiSuccess, null, 'API [200]: Arquivo(s) enviado(s) com sucesso.')  

    //       // LIMPA OS ARQUIVOS DO VETOR
    //       self.input.value = ''

    //       // INICIA O VETOR PARA ADICIONAR OS IDS
    //       var arquivosIds = []

    //       // ADICIONA OS ARQUIVOS RECEBIDOS
    //       for (var index in apiSuccess.lot) {
    //         if (apiSuccess.lot[index].code === '200' && [ '', null, undefined ].indexOf(apiSuccess.lot[index].ref) === -1 && [ '', null, undefined ].indexOf(apiSuccess.lot[index].ref.id) === -1) {
    //           arquivosIds.push(apiSuccess.lot[index].ref.id)
    //         }
    //       }

    //       // CHAMA A FUNÇÃO PARA CARREGAR OS ARQUIVOS DA VENDA
    //       self.armArquivosRecebeQrCodeBuscarArquivos(self, null, arquivosIds)

    //       // CHAMA A FUNÇÃO PARA LIMPAR OS DADOS E VOLTAR O FORMULARIO AO ORIGINAL
    //       self.armArquivosRecebeQrCodeArquivoSalvar()
    //     }, self.armArquivosRecebeQrCodeSetarStatusGeral, null)
    //   } else {
    //     // REMOVE A MASCARA DE ENVIANDO
    //     this.mascara = false

    //     // SETA O STATUS DO BUTTON
    //     this.input.status = ''

    //     // DESABILITA O INPUT PARA INSERIR NOVO
    //     this.input.disabled = false

    //     // SETA OS ARQUIVOS RECEBIDOS
    //     this.input.value = ''

    //     // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
    //     this.time = new Date().getTime()
    //   }
    // }
    demEditarCabFormatarCodigo: function () {
      // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
      const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

      // PEGA A CHAVE REFERENCIA
      var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

      // PEGA O VALOR RECEBIDO E CONVERTE EM STRING
      var valor = this.registro[chaveD].toString()

      // FORMATA O VALOR RETORNADO
      return (valor.length <= 4 ? ('0000' + valor).slice(-4) : valor)
    }
  },
  computed: {
    armArquivosRecebeQrCodeConverterDemanda: function () {
      switch (this.cpntDemanda) {
        case 'venda':
          return 'Venda'

        case 'compra':
          return 'Compra'

        case 'dev_cliente':
          return 'Devolução'

        default:
          return '<span style="color: red;">Erro</span>'
      }
    }
  }
}
</script>
